module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-03-m.5c0f961347b6f51bf460d0867dec4003.png";